/**
 * Applies the input weight multiplier.
 * For example, a single dumbbell weight needs to be doubled (multiplier = 2).
 *
 * @param enteredWeightLb The weight entered by the user.
 * @param inputWeightMultiplier The multiplier for the exercise input type.
 * @returns The total base weight lifted.
 */
export function applyInputMultiplier(
  enteredWeightLb: number,
  inputWeightMultiplier: number,
): number {
  return enteredWeightLb * inputWeightMultiplier;
}

/**
 * Normalizes an estimated 1RM for an exercise to the competition lift equivalent.
 *
 * @param estimated1RmLb The estimated 1RM in pounds.
 * @param normalizationMultiplier The multiplier to convert to the competition lift equivalent.
 * @returns The normalized 1RM in pounds.
 */
export function normalizeToCompetitionLift(
  estimated1RmLb: number,
  normalizationMultiplier: number,
): number {
  return estimated1RmLb * normalizationMultiplier;
}
